import { arrayOf, func, object, shape } from 'prop-types';

const growTypes = {
  data: shape({
    fields: arrayOf(object),
    crops: arrayOf(object),
    storages: arrayOf(object),
    contracts: arrayOf(object),
  }),
  actions: shape({
    updateAll: func,
  }),
};

export default growTypes;



// WEBPACK FOOTER //
// ./src/hoc/grow/proptypes.js